import { z } from 'zod';

export const BoardTypeSchema = z.enum([
  'master',
  'drive_board',
  'io_board',
  'relay_board',
  'sensor_connect',
  'generic',
  // Phase B (2026-05-30): per-axis child of a drive_board. Discovery
  // frames with this type carry a MotorCapabilities payload.
  'stepper_motor',
]);

export const BoardStatusSchema = z.enum(['online', 'offline', 'degraded', 'discovered']);

export const BoardSchema = z.object({
  id: z.string().min(1),
  project_id: z.string().min(1),
  name: z.string().min(1),
  uuid: z.string().min(1),
  status: BoardStatusSchema,
  board_type: BoardTypeSchema,
  can_id: z.number().int().min(0).max(255),
  board_model_id: z.string().nullable(),
  firmware_version: z.string().nullable(),
  last_heartbeat_ms: z.number().int().nullable(),
  parent_board_id: z.string().nullable(),
  archived_at_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
});

export const CreateBoardSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  uuid: z.string().min(1, 'UUID is required'),
  board_type: BoardTypeSchema,
  can_id: z.number().int().min(0).max(255),
  board_model_id: z.string().nullable().optional(),
  parent_board_id: z.string().nullable().optional(),
});

export const UpdateBoardSchema = z.object({
  name: z.string().min(1).optional(),
  can_id: z.number().int().min(0).max(255).optional(),
  board_type: BoardTypeSchema.optional(),
  board_model_id: z.string().nullable().optional(),
  firmware_version: z.string().nullable().optional(),
  parent_board_id: z.string().nullable().optional(),
  status: BoardStatusSchema.optional(),
});

export type ParsedBoard = z.infer<typeof BoardSchema>;
export type ParsedBoardType = z.infer<typeof BoardTypeSchema>;
export type ParsedBoardStatus = z.infer<typeof BoardStatusSchema>;
export type ParsedCreateBoard = z.infer<typeof CreateBoardSchema>;
export type ParsedUpdateBoard = z.infer<typeof UpdateBoardSchema>;
